import { Job } from "../types";
import { ENDPOINTS } from "./endpoints";
import apiClient from "./apiClient";

export interface SuggestJobsResponse {
  jobs: Job[];
  analysis: Record<string, { count: number; percentage: number }>;
}

export const getGeminiToken = async () => {
  const response = await apiClient.get(ENDPOINTS.geminiToken);
  return response.data.token;
};

export const suggestJobs = async (
  sessionId: string
): Promise<SuggestJobsResponse> => {
  const response = await apiClient.post(ENDPOINTS.suggestJobs(sessionId));
  return response.data;
};

export const fetchUserData = async (userId: string) => {
  const response = await apiClient.get(ENDPOINTS.userData(userId));
  return response.data.user;
};

export const logConversation = async (
  payload: Record<string, any>,
  token: string
) => {
  const response = await apiClient.post(ENDPOINTS.logConversation, payload);
  return response.data;
};

interface FeedbackData {
  session_id: string;
  experience_rating?: number | null;
  usability_rating?: number | null;
  recommend_rating?: number | null;
  job_match_satisfaction?: number | null;
  open_remarks?: string;
  reported_issues?: string;
  reporter_email?: string;
}

export const submitFeedback = async (data: FeedbackData) => {
  const response = await apiClient.post(ENDPOINTS.feedback, data);
  return response.data;
};

export const updateRecommendationAction = async (
  recommendationId: number,
  action: string
) => {
  const response = await apiClient.post(
    ENDPOINTS.updateRecommendationAction(recommendationId),
    { action }
  );
  return response.data;
};

export const getSalaryRange = async (country: string) => {
  const response = await apiClient.get(ENDPOINTS.salaryRange(country));
  return response.data.range;
};
